import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import LOOKUP from 'constants/lookup';
import CardSimple from 'screens/components/basic/CardSimple';
import Body from './Body';
import Charts from './Charts';
import Header from './Header';
import Button from 'screens/components/basic/Button';
import { getCombinedSalesReport, getCsvReport } from 'actions/ReportsAction';
import { formInput, clearFormInput } from 'actions/FormActions';
import Pagination from 'screens/components/basic/Pagination';
import reportsUtil from 'utils/reportsApi';
import Grid from 'screens/components/basic/Grid';
import { reportCombinedSales } from 'utils/breadcrumbInfo';
import KnowledgeBase from 'screens/components/basic/KnowledgeBaseIcon';
import { showError } from 'actions/CommonActions';
import { checkDateRange } from 'utils/helpers';
import WithRouter from 'custom/withRouter';

class CombinedSales extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            itemsPerPage: 20,
            showBody: false,
            totalRow: 0,
            model: {
                beginDate: 0,
                endDate: 0,
                branch: 0
            }
        };
        this.showBody = this.showBody.bind(this)
    }

    componentWillMount() {
        const date = new Date()
        this.props.formInput(new Date(date.getFullYear(), date.getMonth(), 1),
            `CombinedSalesBeginDate`);
        this.props.formInput(date, `CombinedSalesEndDate`);
        this.props.formInput(true, `CombinedSales_ShowGrossSales`);
        this.props.formInput(true, `CombinedSales_ShowNetSales`);
        this.props.formInput(true, `CombinedSales_ShowTotalTax`);
        this.props.formInput(true, `CombinedSales_ShowDiscount`);
        this.props.formInput(true, `CombinedSales_ShowGrossProfit`);
    }

    componentWillReceiveProps(newProps) {
        if (newProps.combinedSales && newProps.combinedSales != this.props.combinedSales && newProps.combinedSales != undefined && newProps.combinedSales != null && newProps.combinedSales.list && newProps.combinedSales.list.length > 0) {
            this.setState({ totalRow: newProps.combinedSales.total });
        }
    }

    downloadReport = () => {
        let beginDate = this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let endDate = this.props.endDate ? moment(this.props.endDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let branch = this.props.branch || this.props.loggedBranch;
        let groupby = this.props.groupby || "1";
        let type = this.props.type;
        let onlineType = this.props.onlineType;

        if (checkDateRange(beginDate, endDate)) {
            this.props.showError(LOOKUP.report.common.dateRangeError);
        } else {
            this.props.getCsvReport(`reports/excel/combinedsales?beginDate=${beginDate}&endDate=${endDate}&branchId=${branch}&groupby=${groupby}&type=${type}&onlineType=${onlineType}`, "CombinedSales");
        }
    }

    changePage = (e) => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        }, this.getReport);
    }

    filter = () => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    getReport = () => {
        let beginDate = this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let endDate = this.props.endDate ? moment(this.props.endDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let branch = this.props.branch || this.props.loggedBranch;
        let groupby = this.props.groupby || "1";
        let type = this.props.type;
        let onlineType = this.props.onlineType ? this.props.onlineType : "5";
        let pageNumber = this.state.activePage;
        let pageSize = this.state.itemsPerPage;
        this.props.getCombinedSalesReport({ beginDate, endDate, type, onlineType, pageNumber, pageSize, branch, groupby });
    }

    showBody() {
        if (checkDateRange(this.props.beginDate, this.props.endDate)) {
            this.props.showError(LOOKUP.report.common.dateRangeError);
        } else {
            this.filter();
            this.setState({ showBody: true });
        }
    }

    redirectToReport = () => {
        this.props.navigate("/report");
    }

    render() {
        return (
            <Grid headerContent={reportCombinedSales}>
                <PageHeader 
                    title={LOOKUP.report.combinedSalesReport.text}
                    icon={<KnowledgeBase link="https://knowledge.techpos.ca/en/knowledge/what-is-the-shopping-trend-report" />}
                    description={LOOKUP.report.combinedSalesReport.description}
                />
                <Header
                    branchOptions={this.props.brachOptions}
                    filter={this.filter}
                    download={this.downloadReport}
                    showBody={this.showBody}
                    loggedBranch={this.props.loggedBranch}
                    groups={this.props.groupbyOption}
                    types={this.props.types}
                    onlineTypes={this.props.onlineTypes}

                />
                {
                    this.state.showBody &&
                    <p className="text-right mt-2 blue-text">
                        <i>Generated on : {moment().format('MMMM Do YYYY, h:mm:ss a')}</i>
                    </p>
                }
                {
                    this.state.showBody &&
                    <CardSimple>
                        <Body
                            combinedSales={this.props.combinedSales}
                            beginDate={this.props.beginDate}
                            endDate={this.props.endDate}
                        />
                        <Pagination
                            length={this.state.totalRow}
                            itemsPerPage={this.state.itemsPerPage}
                            activePage={this.state.activePage}
                            onPageChange={this.changePage}
                        />
                        <Charts
                            combinedSales={this.props.combinedSales}
                            beginDate={this.props.beginDate}
                            endDate={this.props.endDate}
                            loggedBranch={this.props.loggedBranch}
                            branchForm={this.props.branch}
                            showGrossSales={this.props.showGrossSales}
                            ShowNetSales={this.props.ShowNetSales}
                            ShowTotalTax={this.props.ShowTotalTax}
                            ShowDiscount={this.props.ShowDiscount}
                            ShowGrossProfit={this.props.ShowGrossProfit}
                            NumberTransactionsCheck={this.props.NumberTransactionsCheck}
                            AverageTransactionCheck={this.props.AverageTransactionCheck}
                            SalesCheck={this.props.SalesCheck}
                        />
                    </CardSimple>
                }
            </Grid>
        );
    }

}

const mapStateToProps = state => {
    let branches = state.common.userBranches || [];
    let brachOptions = [];
    branches.map((item) => {
        brachOptions.push({
            text: item.name, value: item.id.toString()
        });
    });
    let Groups =
        [
            { text: "Daily", value: "4" },
            { text: "Weekly", value: "3" },
            { text: "Monthly", value: "2" },
            { text: "Yearly", value: "1" }
        ];
    let Types =
        [
            { text: "All", value: "3" },
            { text: "Online", value: "2" },
            { text: "Instore", value: "1" }
        ];
    let OnlineTypes =
        [
            { text: "All", value: "5" },
            { text: "Paid Online & Store Pickup", value: "4" },
            { text: "Paid Online & Delivery", value: "3" },
            { text: "Paid Instore & Store Pickup", value: "2" },
            { text: "Express Checkout", value: "1" }
        ];
    return {
        brachOptions: brachOptions,
        combinedSales: state.reports.combinedSales,
        loggedBranch: state.common.branchId,
        beginDate: state.form.CombinedSalesBeginDate,
        endDate: state.form.CombinedSalesEndDate,
        branch: state.form.CombinedSalesBranchOption,
        groupby: state.form.CombinedSalesGroupBy,
        type: state.form.CombinedSalesType,
        onlineType: state.form.CombinedSalesOnlineType,
        groupbyOption: Groups,
        types: Types,
        onlineTypes: OnlineTypes,
        showGrossSales: state.form.CombinedSales_ShowGrossSales,
        ShowNetSales: state.form.CombinedSales_ShowNetSales,
        ShowTotalTax: state.form.CombinedSales_ShowTotalTax,
        ShowDiscount: state.form.CombinedSales_ShowDiscount,
        ShowGrossProfit: state.form.CombinedSales_ShowGrossProfit,
        SalesCheck: state.form.CombinedSalesSalesChart,
        AverageTransactionCheck: state.form.CombinedSalesAverageTransaction,
        NumberTransactionsCheck: state.form.CombinedSalesNumberTransactions
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getCombinedSalesReport: model => dispatch(getCombinedSalesReport(model)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        showError: (message) => dispatch(showError(message)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        getCsvReport: (url, name) => dispatch(getCsvReport(url, name))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(CombinedSales));